import { atom } from "recoil";

export const SettingsStepState = {
  isLoadingAtom: atom<boolean>({
    key: `settingsStepState_isLoading`,
    default: false,
  }),
};
